<template>
    <div>
        <Auth v-if="!authenticated" :loading="loading" :handleAuthLink="openAuth" />
        <router-view  v-else></router-view>
    </div>
</template>

<script>
import Auth from './components/Auth';

import { mapGetters, mapActions } from 'vuex';
import * as type from '../../store/types';

export default {
    components: { Auth },
    computed: {
        ...mapGetters({
            authenticated: `quickbooks/authenticated`,
            loading: `global/loading`
        })
    },
    created(){
        this.connectAuth();
    },
    methods: {
        ...mapActions({
            connectAuth: `quickbooks/${type.QB_CONNECT}`,
            openAuth: `quickbooks/${type.QB_OPEN_AUTH}`,
            
        })
    }
}
</script>